import { render, staticRenderFns } from "./PersonPermissionsDialog.vue?vue&type=template&id=0aed7e5e"
import script from "./PersonPermissionsDialog.vue?vue&type=script&lang=js"
export * from "./PersonPermissionsDialog.vue?vue&type=script&lang=js"
import style0 from "./PersonPermissionsDialog.vue?vue&type=style&index=0&id=0aed7e5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports